﻿import type { MonthlySummary } from '../types';

export function MiniChart({ rows }: { rows: MonthlySummary['dailyTrend'] }) {
  const max = Math.max(1, ...rows.flatMap((r) => [r.expense, r.income, r.investment]));
  const points = (key: 'expense' | 'income' | 'investment') => rows.map((r, i) => `${(i / Math.max(1, rows.length - 1)) * 100},${100 - (r[key] / max) * 90}`).join(' ');
  return <svg className="chart" viewBox="0 0 100 100" preserveAspectRatio="none">
    <polyline points={points('expense')} fill="none" stroke="#dc2626" strokeWidth="2" />
    <polyline points={points('income')} fill="none" stroke="#16a34a" strokeWidth="2" />
    <polyline points={points('investment')} fill="none" stroke="#2563eb" strokeWidth="2" />
  </svg>;
}
